import { render, staticRenderFns } from "./classSignRecord.vue?vue&type=template&id=2719f60f&scoped=true&"
import script from "./classSignRecord.vue?vue&type=script&lang=js&"
export * from "./classSignRecord.vue?vue&type=script&lang=js&"
import style0 from "./classSignRecord.vue?vue&type=style&index=0&id=2719f60f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2719f60f",
  null
  
)

export default component.exports